export const CHECK_POST = '@@checkApi/checkPost'
export const CHECK_POST_FAILED = '@@checkApi/checkPostFailed'

export const OPEN_ERROR_POPUP = '@@checkApi/openErrorPopup'
export const CLOSE_ERROR_POPUP = '@@checkApi/closeErrorPopup'
